import { iconIds as appIcons } from '@/lib/appIcons'

export default function useAppIcons() {
  return {
    appIcons
  }
}
